import { Alert as ShrikeAlert } from '@perch-labs/shrike';
import styled from 'styled-components';
import { space } from 'styled-system';
import { Link } from '~/components/link';

export const Alert = styled(ShrikeAlert)`
  margin: 0;
  ${space}
`;

export const HelpDialogLink = styled(Link)`
  color: inherit;
`;
